import React, { useContext } from 'react';
import './Webstore.less';
import { Switch, Route, Redirect } from 'react-router-dom';
import { AuthContext } from 'util/Auth';
import { CountryDetectionContext } from 'util/CountryDetection';
import STORES from 'config/stores';
import AccessDenied from 'pages/AccessDenied/AccessDenied';
import { getRememberedWebstoreStore } from 'util/webstore';
import RequestProducts from './RequestProducts/RequestProducts';
import OrderMerch from './OrderMerch/OrderMerch';
import ReviewWebstoreRequests from './ReviewWebstoreRequests/ReviewWebstoreRequests';
import ShippingRates from './ShippingRates/ShippingRates';
import SiteBuilds from './SiteBuilds/SiteBuilds';
import FreshClub from './FreshClub/FreshClub';
import AddOnetimes from './AddOnetimes/AddOnetimes';
import FreshClubDateRoll from './FreshClubDateRoll';
import WildClub from './WildClub/WildClub';
import WildClubDateRoll from './WildClubDateRoll';

const WEBSTORE_ADMINS = [
  'dev@garageproject.co.nz',
  'mitchell@garageproject.co.nz',
  'leyton@garageproject.co.nz',
  'tyler@garageproject.co.nz',
  'kyle@garageproject.co.nz',
  'websales@garageproject.co.nz',
  'websales@garageproject.com.au',
  'tyler.h@garageproject.co.nz',
  'asif@garageproject.co.nz',
  'george@garageproject.co.nz',
  'jamie@garageproject.co.nz',
];

const resolveDefaultStore = (country) => {
  const remembered = getRememberedWebstoreStore(Object.values(STORES));
  if (remembered) {
    return remembered;
  }
  return country?.code === 'AU' ? STORES.GPAU : STORES.GPNZ;
};

const Webstore = () => {
  const { currentUser } = useContext(AuthContext);
  // RouteHandler already waited for CountryDetectionContext — no second ipwhois call.
  const { country } = useContext(CountryDetectionContext);
  const defaultStore = resolveDefaultStore(country);

  const webstoreAdmin = WEBSTORE_ADMINS.includes(currentUser.email);
  return (
    <Switch>
      <Route
        exact
        path="/dashboard/webstore/request"
        render={() => (
          <RequestProducts
            webstoreAdmin={webstoreAdmin}
            defaultStore={defaultStore}
          />
        )}
      />
      <Route
        exact
        path="/dashboard/webstore/review-requests"
        // TODO: Implement fine grained permissions
        // render={() => (currentUser.admin ? <ReviewWebstoreRequests /> : <AccessDenied />)}
        render={() => (
          webstoreAdmin ? (
            <ReviewWebstoreRequests defaultStore={defaultStore} />
          ) : (
            <AccessDenied />
          )
        )}
      />
      <Route
        exact
        path="/dashboard/webstore/shipping-rates"
        render={() => (
          webstoreAdmin ? (
            <ShippingRates />
          ) : (
            <AccessDenied />
          )
        )}
      />
      <Route
        exact
        path="/dashboard/webstore/builds"
        render={() => (
          webstoreAdmin ? (
            <SiteBuilds />
          ) : (
            <AccessDenied />
          )
        )}
      />
      <Route
        exact
        path="/dashboard/webstore/order-merch"
        render={() => (
          <OrderMerch
            webstoreAdmin={webstoreAdmin}
            defaultStore={defaultStore}
          />
        )}
      />
      <Route
        exact
        path="/dashboard/webstore/fresh-club"
        render={() => (
          <FreshClub
            webstoreAdmin={webstoreAdmin}
            defaultStore={defaultStore}
          />
        )}
      />
      <Route
        exact
        path="/dashboard/webstore/fresh-club-onetimes"
        render={() => (
          <AddOnetimes
            webstoreAdmin={webstoreAdmin}
            defaultStore={defaultStore}
          />
        )}
      />
      <Route
        exact
        path="/dashboard/webstore/fresh-club-date-roll"
        render={() => (
          <FreshClubDateRoll defaultStore={defaultStore} />
        )}
      />
      <Route
        exact
        path="/dashboard/webstore/wild-club"
        render={() => (
          <WildClub />
        )}
      />
      <Route
        exact
        path="/dashboard/webstore/wild-club-date-roll"
        render={() => (
          <WildClubDateRoll />
        )}
      />
      <Redirect to="/dashboard/webstore/request" />
    </Switch>
  );
};

export default Webstore;
